import React, { useMemo, useState } from 'react';
import './ContactUs.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const API_URL = 'https://api.salesninjacrm.com/migration/lead/assign';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    cont_rvusersfName: '',
    cont_rvuserslName: '',
    cont_rvrmobile: '',
    cont_rvruserEmail: '',
    cont_rvusersfArn: '',
    cont_rvusersfCity: '',
    rvcontact_cont_captcha: '',
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState('');
  const [captcha, setCaptcha] = useState({ a: 9, b: 9 });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const captchaAnswer = useMemo(() => captcha.a + captcha.b, [captcha]);

  const refreshCaptcha = () => {
    const a = Math.floor(Math.random() * 9) + 1;
    const b = Math.floor(Math.random() * 9) + 1;

    setCaptcha({ a, b });

    setFormData((prev) => ({
      ...prev,
      rvcontact_cont_captcha: '',
    }));

    setErrors((prev) => ({
      ...prev,
      rvcontact_cont_captcha: '',
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let finalValue = value;

    if (name === 'cont_rvrmobile') {
      finalValue = value.replace(/[^0-9]/g, '').slice(0, 10);
    }

    if (name === 'rvcontact_cont_captcha') {
      finalValue = value.replace(/[^0-9]/g, '').slice(0, 2);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: '',
      apiError: '',
    }));

    setSuccessMessage('');
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.cont_rvusersfName.trim()) {
      newErrors.cont_rvusersfName = 'First name is required';
    }

    /*
      Last name API sample me empty hai:
      "lastName": ""
      Isliye last name optional hai.
    */

    if (!formData.cont_rvrmobile.trim()) {
      newErrors.cont_rvrmobile = 'Mobile number is required';
    } else if (!/^[0-9]{10}$/.test(formData.cont_rvrmobile)) {
      newErrors.cont_rvrmobile = 'Enter valid 10 digit mobile number';
    }

    if (!formData.cont_rvruserEmail.trim()) {
      newErrors.cont_rvruserEmail = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.cont_rvruserEmail)) {
      newErrors.cont_rvruserEmail = 'Enter valid email address';
    }

    if (!formData.cont_rvusersfArn.trim()) {
      newErrors.cont_rvusersfArn = 'ARN No is required';
    }

    if (!formData.cont_rvusersfCity.trim()) {
      newErrors.cont_rvusersfCity = 'City is required';
    }

    if (!formData.rvcontact_cont_captcha.trim()) {
      newErrors.rvcontact_cont_captcha = 'Captcha is required';
    } else if (Number(formData.rvcontact_cont_captcha) !== captchaAnswer) {
      newErrors.rvcontact_cont_captcha = 'Captcha answer is wrong';
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({
      cont_rvusersfName: '',
      cont_rvuserslName: '',
      cont_rvrmobile: '',
      cont_rvruserEmail: '',
      cont_rvusersfArn: '',
      cont_rvusersfCity: '',
      rvcontact_cont_captcha: '',
    });

    refreshCaptcha();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm();

    if (!isValid) {
      return;
    }

    const payload = {
      firstName: formData.cont_rvusersfName.trim(),
      lastName: formData.cont_rvuserslName.trim(),
      mobile: formData.cont_rvrmobile.trim(),
      email: formData.cont_rvruserEmail.trim(),
      arn_no: formData.cont_rvusersfArn.trim(),
      city: formData.cont_rvusersfCity.trim(),
      product: 'SalesNinja MFD CRM (Annual Package)',
      source: 'SalesNinja Website',
      organizationId: 'RED-3942-5175',
    };

    try {
      setIsSubmitting(true);
      setSuccessMessage('');

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(result?.message || 'Something went wrong. Please try again.');
      }

      setSuccessMessage('Thank you! Your demo request has been submitted successfully.');
      resetForm();
    } catch (error) {
      console.error('Lead API Error:', error);

      setErrors((prev) => ({
        ...prev,
        apiError: error.message || 'Something went wrong. Please try again.',
      }));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="main-section contact-section contact-hero" id="contactus">
      <div className="cta-glow"></div>

      <div className="rev text-center section-hadding">
        <div className="sec-label">Contact Us</div>

        <h2 className="sec-h2">
          Book Your Free <br />
          <em>Demo </em> Today
        </h2>

        <p>
          Fill in your details and our team will reach out to you. No sales pressure,
          just your workflow discussion & the features that can benefit you.
        </p>
      </div>

      <div className="form-box">
        <div className="rvfrhcontent-box">
          <form
            id="secureForm"
            data-key="cont"
            onSubmit={handleSubmit}
          >
            <input
              type="hidden"
              name="cont_hp_rvcontact"
              className="honeypot"
              value=""
              readOnly
            />

            <div className="rvsf-rows">
              <div className="form-group rvsf-cols">
                <label htmlFor="rvrfname_cont">First Name</label>

                <div className="input-icone">
                  <i className="fa-solid fa-user"></i>
                  <input
                    type="text"
                    className="vldatayes"
                    name="cont_rvusersfName"
                    id="rvrfname_cont"
                    value={formData.cont_rvusersfName}
                    onChange={handleChange}
                  />
                </div>

                <span id="rvrfname_err_cont" className="error">
                  {errors.cont_rvusersfName}
                </span>
              </div>

              <div className="form-group rvsf-cols">
                <label htmlFor="rvrlname_cont">Last Name</label>

                <div className="input-icone">
                  <i className="fa-solid fa-user"></i>
                  <input
                    type="text"
                    className="vldatayes"
                    name="cont_rvuserslName"
                    id="rvrlname_cont"
                    value={formData.cont_rvuserslName}
                    onChange={handleChange}
                  />
                </div>

                <span id="rvrlname_err_cont" className="error">
                  {errors.cont_rvuserslName}
                </span>
              </div>

              <div className="form-group rvsf-cols">
                <label htmlFor="mobile_cont">Mobile</label>

                <div className="input-icone">
                  <i className="fa-solid fa-phone"></i>
                  <input
                    type="tel"
                    className="vldatayes"
                    name="cont_rvrmobile"
                    id="mobile_cont"
                    maxLength="10"
                    pattern="[0-9]{10}"
                    value={formData.cont_rvrmobile}
                    onChange={handleChange}
                  />
                </div>

                <span id="rvrmobile_err_cont" className="error">
                  {errors.cont_rvrmobile}
                </span>
              </div>

              <div className="form-group rvsf-cols">
                <label htmlFor="rvremail_cont">Email</label>

                <div className="input-icone">
                  <i className="fa-solid fa-envelope"></i>
                  <input
                    type="email"
                    className="vldatayes"
                    name="cont_rvruserEmail"
                    id="rvremail_cont"
                    value={formData.cont_rvruserEmail}
                    onChange={handleChange}
                  />
                </div>

                <span id="rvremail_err_cont" className="error">
                  {errors.cont_rvruserEmail}
                </span>
              </div>

              <div className="form-group rvsf-cols">
                <label htmlFor="rvrfarn_cont">ARN No</label>

                <div className="input-icone">
                  <i className="fa-solid fa-id-card"></i>
                  <input
                    type="number"
                    className="vldatayes"
                    name="cont_rvusersfArn"
                    id="rvrfarn_cont"
                    value={formData.cont_rvusersfArn}
                    onChange={handleChange}
                  />
                </div>

                <span id="rvrfarn_err_cont" className="error">
                  {errors.cont_rvusersfArn}
                </span>
              </div>

              <div className="form-group rvsf-cols">
                <label htmlFor="rvrfcity_cont">City</label>

                <div className="input-icone">
                  <i className="fa-solid fa-location-dot"></i>
                  <input
                    type="text"
                    className="vldatayes"
                    name="cont_rvusersfCity"
                    id="rvrfcity_cont"
                    value={formData.cont_rvusersfCity}
                    onChange={handleChange}
                  />
                </div>

                <span id="rvrfcity_err_cont" className="error">
                  {errors.cont_rvusersfCity}
                </span>
              </div>

              <div className="form-group captcha-group">
                <label htmlFor="rvfcaptcha">
                  Solve:{' '}
                  <b id="cap_rvcontact_cont">
                    {captcha.a} + {captcha.b}
                  </b>{' '}
                  = ?
                </label>

                <div className="captcha-input-wrap">
                  <input
                    type="number"
                    name="rvcontact_cont_captcha"
                    id="rvfcaptcha"
                    maxLength="2"
                    required
                    value={formData.rvcontact_cont_captcha}
                    onChange={handleChange}
                  />

                  <span
                    onClick={refreshCaptcha}
                    id="refreshCaptcha"
                    role="button"
                    tabIndex="0"
                  >
                    ↻
                  </span>
                </div>

                <span className="error">{errors.rvcontact_cont_captcha}</span>
              </div>
            </div>

            {successMessage && (
              <div className="api-success-message">
                {successMessage}
              </div>
            )}

            {errors.apiError && (
              <div className="api-error-message">
                {errors.apiError}
              </div>
            )}

            <div className="back-links text-center">
              <button
                type="submit"
                className="btn-fill"
                id="submitBtn_cont"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;